<form class="itinerary-model-content-inner" [formGroup]="notesForm" (ngSubmit)="onSubmit()">
  <div class="itinerary-model-content">
    <div class="box-title-container mb-1">
      <div class="">
        <div class="d-flex align-items-center">
          <div class="icon-container">
            <ion-icon name="clipboard"></ion-icon>
          </div>
          <div>
            <p class="title">Notes <span class="text-danger warning-message" *ngIf="notesForm.get('notes')?.invalid && notesForm.get('notes')?.touched">Required / Invalid</span></p>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="dmcPackageNotes" class="ion-padding-horizontal">
      <div class="row">
        <div class="col-12">
          <div class="input-container">
            <div class="d-flex justify-content-between align-items-center">
              <label class="label">DMC Notes</label>
              <div>
                <!-- TODO: complete copy feature -->
                <!-- <ion-button class="sm-btn" fill="clear" size="small" (click)="copyDmcNotesToClipboard()" [disabled]="dmcNotesCopied">
                  <ion-icon name="copy-outline"></ion-icon> {{ dmcNotesCopied ? 'Copied' : 'Copy' }}
                </ion-button> -->
              </div>
            </div>
            
            <div class="dmc-notes-container border border-1 rounded p-2">
              <div [innerHTML]="dmcPackageNotes"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="input-container">
            <label class="label">Agent Notes</label>
          </div>
        </div>
      </div>
    </div>
    
  
    <div class="form-container ion-padding-horizontal">
      <div class="row">
        <div class="col">
          <div class="input-container">
            <app-text-formatting-input formControlName="notes" [inputHeight]="'lg'"></app-text-formatting-input>
          </div>
        </div>
      </div>
    </div>
    <div class="dashed-line"></div>
  </div>

  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
        Save
      </ion-button>
      <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
        Save & Next
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</form>
